export default {
  getAuthStatus(state) {
    return state.isAuthenticated;
  }
}
